module.exports = __webpack_public_path__ + "media/images/orion_pictos/money-9ebb6ccd82fd9fbd339e64e2bc945f23.svg";